import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from "react-query";
//import { ReactQueryDevtools } from 'react-query/devtools'

import './i18n';


const queryClient = new QueryClient({});

ReactDOM.render(
  <React.StrictMode>
     <QueryClientProvider client={queryClient}>   
     <Suspense fallback={<div>Loading...</div>}>
     <App />
     </Suspense>
     </QueryClientProvider>  
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
